import { BaseSettings } from 'Shared/frontend/themes/BaseSettings';
import { NunitoSans } from 'Shared/frontend/fonts/NunitoSans';
import { NoticiaText } from 'Shared/frontend/fonts/NoticiaText';
import { INav } from 'Common/config/INav';
import {PeopleCircle as BackendPeopleCircle} from 'Shared/backend/icons/PeopleCircle'; 
import { Contact } from 'Shared/frontend/icons/Contact';
import {Calendar} from 'Shared/frontend/icons/Calendar';
import {FoodMenu} from 'Shared/frontend/icons/FoodMenu';
import {Home} from 'Shared/frontend/icons/Home';




export class LucillesSettings extends BaseSettings
{

	fontIncludes()
	{
		return [
			NunitoSans,
			NoticiaText,
		];
	}

	fonts()
	{
		return {
			text: '"Nunito Sans", sans-serif',
			heading:  '"Noticia Text", serif',
			subNav:  '"Noticia Text", serif',
			buttons:  '"Noticia Text", serif',
			desktopNav:  '"Noticia Text", serif',
			mobileNav:  '"Noticia Text", serif',
		};
	}

	pages()
	{
		return [
			{
				key: 'home',
				frontend: {
					route: '/',
					metaTitle: 'Home'
				},
				backend: {
					route: '/home',
					title: 'Home'
				}
			},
			{
				key: 'events',
				frontend: {
					route: '/events',
					metaTitle: 'Events'
				},
				backend: {
					route: '/events-design',
					title: 'Events'
				}
			},
			{
				key: 'book',
				frontend: {
					route: '/book',
					metaTitle: 'Book'
				},
				backend: {
					route: '/book',
					title: 'Book'
				}
			},
			{
				key: 'hire',
				frontend: {
					route: '/hire',
					metaTitle: 'Hire'
				},
				backend: {
					route: '/hire',
					title: 'Hire'
				}
			},
			{
				key: 'contact',
				frontend: {
					route: '/contact',
					metaTitle: 'Contact'
				},
				backend: {
					route: '/contact',
					title: 'Contact'
				}
			},
		];
	}

	navContent(): INav
	{
		return {
			desktop: [
				{label:'Home',		link:'frontend/Home'},
				{label:'Menus',		link:'frontend/Menu'},
				{label:'Events',	link:'frontend/Events'},
				//Todo Ben book buttons are not linking to page
			//	{label:'Book',		link:'frontend/Book'},
				{label:'Hire',		link:'frontend/Hire'},
				{label:'Contact',	link:'frontend/Contact'},

			],
			mobile: {
				maxButtons: 5,
				includeMoreButton: true,
				
				links: [
					{label:'Home',		link:'frontend/Home',		icon:Home},
					{label:'Menus',		link:'frontend/Menu',		icon:FoodMenu},
					{label:'Events',	link:'frontend/Events',		icon:Calendar},
					{label:'Hire',		link:'frontend/Hire', 		icon:Contact},
				//	{label:'Book',		link:'frontend/Book', 	icon:PeopleCircle},
					{label:'Contact',	link:'frontend/Contact',	icon:Contact},
				]
			}
		};
	}

	backendNavContent()
	{
		return [
			...super.backendNavContent(),
			{label:'Staff',		route:'/admin/staffResources',	icon:BackendPeopleCircle},
		];
	}

}

